<template>
  <v-layout row wrap white>
    <v-flex xs4 ml-4>
      <v-text-field
        v-model="prepository_name"
        label="Procurar preposto"
        append-icon="search"
        @click:append="search"
        v-on:keydown.enter.prevent="search"
      />
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  data () {
    return {
      prepository_name: ''
    }
  },
  props: {
    searchPrepositorys: Function
  },
  methods: {
    search () {
      this.$props.searchPrepositorys({ prepository_name: this.prepository_name })
    }
  }
}
</script>

<style>
</style>
